(function() {
  const ELM_anchors = document.querySelectorAll('[wc-anchor]');

  ELM_anchors?.forEach(ELM_anchor => ELM_anchor.addEventListener('click', e => {
    e.preventDefault();
    const ELM_targetSection = document.querySelector(`${ELM_anchor.getAttribute('href')}`);
    ELM_targetSection.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }))

  const ELM_fakeSpots = document.querySelectorAll('[fake-hotspot]');
  ELM_fakeSpots?.forEach(ELM_fakeSpot => ELM_fakeSpot.addEventListener('click', e => {
    e.stopPropagation();
    const ELM_hotspotButton = ELM_fakeSpot.closest('.collage__item__hotspot');
    ELM_hotspotButton.classList.toggle('active');
  }))
})();
